'use client';

import React, { useRef } from 'react';
import { Flag } from 'lucide-react';
import FeedbackDialog, { type FeedbackDialogHandle } from './FeedbackDialog';

// "Report a problem on this page": a small link at the foot of every page that
// opens the feedback form in a dialog. The report carries the page's address,
// language and device, so the person only has to say what is wrong.

export default function ReportProblemButton({
  lang,
  className = '',
  short = false,
}: {
  lang: string;
  className?: string;
  /** "Report a problem", no icon - for a list of links (the site footer). */
  short?: boolean;
}) {
  const isFr = lang === 'fr';
  const dialog = useRef<FeedbackDialogHandle>(null);

  return (
    <>
      <button type="button" onClick={() => dialog.current?.open()} className={`inline-flex items-center gap-1.5 cursor-pointer ${className}`}>
        {!short && <Flag className="w-3.5 h-3.5" />}
        {short
          ? (isFr ? 'Signaler un problème' : 'Report a problem')
          : (isFr ? 'Signaler un problème sur cette page' : 'Report a problem on this page')}
      </button>
      <FeedbackDialog ref={dialog} lang={lang} kind="page_error" title={isFr ? 'Signaler un problème' : 'Report a problem'} showPage />
    </>
  );
}
